const jobsCalendar = {
  view: 'View',
  calendarView: {
    monthly: 'Monthly',
    weekly: 'Weekly',
  },

  modalRemoveConfirm: {
    header: 'Warning!',
    bodySingle: 'Are you sure you want to delete this booking?',
    bodyMultiple: 'Are you sure you want to delete these bookings?',
    confirmBtn: 'Delete',
  },

  calendarTable: {
    actions: {
      delete: 'Delete'
    },
    cells: {
      dayOff: 'DayOff',
    },
    headers: {
      name: 'Name',
      monday: 'Monday {{day}}',
      tuesday: 'Tuesday {{day}}',
      wednesday: 'Wednesday {{day}}',
      thursday: 'Thursday {{day}}',
      friday: 'Friday {{day}}',
      saturday: 'Saturday {{day}}',
      sunday: 'Sunday {{day}}',
    },
  },

  filters: {
    profiles: 'Profiles',
    students: 'Students',
    caregivers: 'Caregivers',
    employees: 'Employees',
    passengers: 'Passengers',
  }, 

  shiftsFilter:{
    all:'All Passengers',
    withShift: 'Passengers with Shifts',
    withoutShifts: 'Passengers Without Shifts',
  },
};

export default jobsCalendar;